import { EmailTemplate, EmailTemplateCategory } from '@spike/email-marketing-model';
import { FunctionComponent } from 'react';
import EmailTemplateCategorySection from './EmailTemplateCategorySection';

interface TemplatesByCategory {
    category: EmailTemplateCategory | 'all';
    templates: EmailTemplate[];
}

interface EmailTemplatesListProps {
    templatesByCategory: TemplatesByCategory[];
    onSelectTemplate?: (template: EmailTemplate) => void;
    /** Required — forwarded straight to every Card via the section. */
    onPreviewTemplate: (template: EmailTemplate) => void;
}

const EmailTemplatesList: FunctionComponent<EmailTemplatesListProps> = ({
    templatesByCategory,
    onSelectTemplate,
    onPreviewTemplate
}) => {
    return (
        <div>
            {templatesByCategory.map(({ category, templates }) => (
                <EmailTemplateCategorySection
                    key={category}
                    category={category}
                    templates={templates}
                    onSelectTemplate={onSelectTemplate}
                    onPreviewTemplate={onPreviewTemplate}
                />
            ))}
        </div>
    );
};

export default EmailTemplatesList;
